import React from "react";
import { Link } from "react-router-dom";
import { Newsletter } from "@/components/Newsletter";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="relative h-[60vh] min-h-[420px] overflow-hidden">
        <img
          src="https://images.pexels.com/photos/21550490/pexels-photo-21550490.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Coastal waves"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-navy/80 via-navy/40 to-transparent" />
        <div className="relative z-10 h-full flex items-end max-w-7xl mx-auto px-6 md:px-12 pb-16 text-white">
          <div>
            <p className="b2t-overline !text-seafoam-400 mb-3">Our Story</p>
            <h1 className="font-display text-5xl md:text-6xl font-bold tracking-tight max-w-2xl leading-[0.95]">
              Built between<br />
              <span className="italic font-light text-seafoam-400">the docks and the dunes.</span>
            </h1>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 px-6 md:px-12 bg-white">
        <div className="max-w-3xl mx-auto space-y-6 text-navy/75 leading-relaxed">
          <p className="text-xl text-navy font-display">
            Boat 2 Tee is coastal lifestyle apparel for people who don't choose between tides and tee times. We build it for both.
          </p>
          <p>
            We started Boat 2 Tee because we got tired of having two wardrobes — one for the boat, one for the course. Stuff that's built for fishing rarely looks good anywhere else. Golf apparel doesn't hold up at the marina. We wanted gear that earned its place in the rotation. Performance fabrics. Tailored fits. Embroidered details that nod to the lifestyle without shouting it.
          </p>
          <p>
            Every piece we make starts with the same question: would I wear this dock to dinner, fairway to fish camp? If the answer's no, it doesn't get made.
          </p>
          <p className="font-display text-xl text-navy italic">— The Boat 2 Tee crew</p>
        </div>
      </section>

      <section className="py-16 md:py-20 px-6 md:px-12 bg-sand">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            { title: "Premium Fabrics", body: "UPF 50+ performance knits, Pima-blend polos, brushed-interior quarter-zips. We only ship what we'd reorder." },
            { title: "Tailored Fits", body: "Cut for active days. Tapered enough to look sharp, roomy enough to cast, swing, and breathe." },
            { title: "Coastal Details", body: "Embroidered B2T anchor and tee-mark insignias. Sleeve hits where the brand makes sense — never busy." },
          ].map((b) => (
            <div key={b.title} className="bg-white p-8 border border-navy/5">
              <h3 className="font-display text-xl font-bold text-navy mb-3">{b.title}</h3>
              <p className="text-sm text-navy/65 leading-relaxed">{b.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 md:py-24 px-6 md:px-12 text-center">
        <Link
          to="/shop"
          data-testid="about-shop-cta"
          className="inline-flex items-center gap-2 bg-navy text-white px-10 py-4 text-xs font-bold uppercase tracking-[0.22em] hover:bg-seafoam hover:text-navy transition-colors"
        >
          Shop the Collection
        </Link>
      </section>

      <Newsletter />
    </div>
  );
}
